import { render, staticRenderFns } from "./MyTeamsWebpart.vue?vue&type=template&id=21221fd8"
import script from "./MyTeamsWebpart.ts?vue&type=script&lang=ts&external"
export * from "./MyTeamsWebpart.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports